export const disableItemSelection = (preferences) => {
    const columns = preferences?.columns?.filter(item => item.show === true)
    return columns?.length === 0
  }

export const normalizeTagIds = (tagIds) => {
  if (Array.isArray(tagIds)) return tagIds;

  if (typeof tagIds === "string") {
    try {
      const parsedTagIds = JSON.parse(tagIds);
      return Array.isArray(parsedTagIds) ? parsedTagIds : [];
    } catch (error) {
      return [];
    }
  }

  return [];
};

export const resolveDriverSupervisor = (driver, supervisors) => {
  if (driver?.supervisorId) {
    const supervisorById = supervisors?.find(
      (item) => String(item?.id) === String(driver.supervisorId)
    );
    if (supervisorById) {
      return supervisorById;
    }
  }
  if (driver?.supervisor?.firstName || driver?.supervisor?.lastName) {
    return driver.supervisor;
  }
  return null;
};

export const doesDriverMatchView = (driver, { filters, searchText, supervisors }) => {
  const activeFilters = filters || {};
  const currentUnitId = String(driver?.unit?.id || driver?.unitId || "");
  const currentTagIds = normalizeTagIds(driver?.tagIds);

  if (!activeFilters.includeInactiveDrivers && Number(driver?.status) === 0) {
    return false;
  }

  if (!activeFilters.unassigned && !currentUnitId) {
    return false;
  }

  if (activeFilters.tagIds?.length && activeFilters.tagIds[0] !== -99) {
    const selectedTagIds = activeFilters.tagIds.map((tagId) => String(tagId));
    const matchesSelectedTag = selectedTagIds.some(
      (tagId) => tagId !== "-1" && currentTagIds.some((currentTagId) => String(currentTagId) === tagId)
    );
    const matchesUntagged = selectedTagIds.includes("-1") && currentTagIds.length === 0;

    if (!matchesSelectedTag && !matchesUntagged) {
      return false;
    }
  }

  if (activeFilters.unitIds?.length && activeFilters.unitIds[0] !== "-99") {
    const selectedUnitIds = activeFilters.unitIds.map((unitId) => String(unitId));
    if (!selectedUnitIds.includes(currentUnitId)) {
      return false;
    }
  }

  if (searchText?.trim()) {
    const normalizedSearchText = searchText.trim().toLowerCase();
    const supervisor = resolveDriverSupervisor(driver, supervisors);
    const searchValues = [
      driver?.name,
      driver?.externalId,
      supervisor?.firstName,
      supervisor?.lastName,
    ];

    const matchesSearch = searchValues.some((value) =>
      value?.toLowerCase().includes(normalizedSearchText)
    );

    if (!matchesSearch) {
      return false;
    }
  }

  return true;
};

// Socket payload -> table row. px-cloud sends only the changed DB columns (title, driver_tz_id, ...)
// plus unit ({ id, label, icon } or null), so it's merged over the current row.
export const buildDriverRowFromSocket = (payload, currentRow) => {
  // eslint-disable-next-line no-unused-vars
  const { title, driver_tz_id, unit, event, ...values } = payload;
  const row = { ...(currentRow || {}) };

  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined) row[key] = value;
  });

  const driverId = String(payload.id || payload.driverId || payload.entityId);
  row.id = driverId;
  row.driverId = currentRow?.driverId ?? driverId;
  if (title !== undefined) row.name = title;
  if (driver_tz_id !== undefined) row.idTimeZone = driver_tz_id;
  if (unit !== undefined) {
    row.unit = unit ? { id: unit.id, label: unit.label } : null;
    row.unitId = unit?.id ?? null;
  }

  return row;
};
